import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getSubtypes.success: {
            return action.payload;
        }

        case constants.getSubtypes.try:
        case constants.getSubtypes.error: {
            return initialState;
        }

        default:
            return state;
    }
}
